<mat-progress-bar [value]="value * 100" ></mat-progress-bar>
<div class="progress-text">
    {{value | percent}}
</div>